import React, { memo } from 'react'
import {
    Container,
    AppBar,
    Toolbar,
    useScrollTrigger,
    LinearProgress,
} from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'
import PhoneEnabledOutlinedIcon from '@material-ui/icons/PhoneEnabledOutlined'

function ElevationScroll(props) {
    const { children } = props
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
    })

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
    })
}

const useStyles = makeStyles((theme) => ({
    loading: {
        borderBottom: 'none',
    },
    default: {
        borderBottom: '2px solid #F4F4F4',
    },
    wrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: 0,
        paddingRight: 0,
        [theme.breakpoints.up('md')]: {
            padding: `0 ${theme.spacing(6)}px`,
        },
    },
    brandLogo: {
        width: 150,
        [theme.breakpoints.up('sm')]: {
            width: 300,
        },
    },
    phoneNumberWrapper: {
        color: theme.palette.primary.main,
        display: 'flex',
        alignItems: 'center',
        fontSize: '0.9rem',
        textDecoration: 'none',
        [theme.breakpoints.up('sm')]: {
            fontSize: '1.1rem',
        },
    },
    phoneNumber: {
        fontWeight: 'bold',
        marginLeft: '0.2rem',
        [theme.breakpoints.up('sm')]: {
            marginLeft: '0.5rem',
        },
    },
}))

const Header = (props) => {
    const classes = useStyles()
    const { logoUrl, logoImage, loading } = props

    return (
        <>
            <ElevationScroll {...props}>
                <AppBar
                    position="fixed"
                    style={{ background: '#FFF' }}
                    className={loading ? classes.loading : classes.default}
                >
                    <Toolbar>
                        <Container className={classes.wrapper}>
                            <a
                                className={`brand-logo printable`}
                                href={logoUrl}
                                title="Back to homepage"
                            >
                                <img
                                    className={classes.brandLogo}
                                    src={logoImage}
                                    alt={'Brand Logo'}
                                    width={'300px'}
                                />
                            </a>
                            <a
                                href="tel:+18556606847"
                                className={classes.phoneNumberWrapper}
                            >
                                <PhoneEnabledOutlinedIcon fontSize="inherit" />
                                <span className={classes.phoneNumber}>
                                    (855) 660-6847
                                </span>
                            </a>
                        </Container>
                    </Toolbar>
                    {loading && <LinearProgress />}
                </AppBar>
            </ElevationScroll>
            <Toolbar />
        </>
    )
}
export default memo(Header)
